import { webPaths } from '../../routes/pageRoutes';
import { useLocation, useNavigate } from 'react-router-dom';

const LogoutModal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div
      class="modal fade logout-modal"
      id="logoutModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="logout-icon">
            <svg
              width="66"
              height="66"
              viewBox="0 0 66 66"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M55.9458 47.1797H51.4147C51.1053 47.1797 50.8153 47.315 50.6219 47.5535C50.1708 48.1013 49.6874 48.6299 49.1782 49.1326C47.0957 51.2173 44.6289 52.8785 41.9143 54.0246C39.102 55.2125 36.0792 55.8218 33.0262 55.8164C29.9389 55.8164 26.9483 55.2105 24.1382 54.0246C21.4235 52.8785 18.9568 51.2173 16.8743 49.1326C14.7881 47.055 13.1245 44.5926 11.9758 41.8816C10.7835 39.0715 10.1841 36.0873 10.1841 33C10.1841 29.9127 10.7899 26.9285 11.9758 24.1183C13.1231 21.4049 14.7731 18.9621 16.8743 16.8674C18.9755 14.7726 21.4182 13.1226 24.1382 11.9754C26.9483 10.7894 29.9389 10.1836 33.0262 10.1836C36.1135 10.1836 39.1042 10.783 41.9143 11.9754C44.6342 13.1226 47.077 14.7726 49.1782 16.8674C49.6874 17.3765 50.1643 17.9051 50.6219 18.4465C50.8153 18.6849 51.1118 18.8203 51.4147 18.8203H55.9458C56.3518 18.8203 56.6032 18.3691 56.3776 18.0275C51.4341 10.3447 42.7844 5.25935 32.9553 5.28513C17.5124 5.3238 5.13093 17.8599 5.28561 33.2836C5.4403 48.4623 17.8024 60.7148 33.0262 60.7148C42.8296 60.7148 51.4405 55.6359 56.3776 47.9724C56.5968 47.6308 56.3518 47.1797 55.9458 47.1797ZM61.6757 32.5939L52.5298 25.3752C52.1882 25.1045 51.6919 25.3494 51.6919 25.7812V30.6797H31.4536C31.17 30.6797 30.938 30.9117 30.938 31.1953V34.8047C30.938 35.0883 31.17 35.3203 31.4536 35.3203H51.6919V40.2187C51.6919 40.6506 52.1946 40.8955 52.5298 40.6248L61.6757 33.406C61.7373 33.3578 61.7871 33.2962 61.8214 33.2258C61.8557 33.1555 61.8735 33.0782 61.8735 33C61.8735 32.9217 61.8557 32.8445 61.8214 32.7741C61.7871 32.7038 61.7373 32.6422 61.6757 32.5939Z"
                fill="black"
              />
            </svg>
          </div>

          <h5 class="logout-title ct_fs_21 ct_fw_500 mt-3">
            Are you sure you want to Log Out?
          </h5>
          <p class="logout-subtitle ct_fs_18 ct_fw_500 my-3 ct_text_clr_4B5563">
            You will need to sign in again to access your assets and account features.
          </p>

          <div class="logout-actions mt-3">
            <button class="outline_btn w-100" data-bs-dismiss="modal">
              Cancel
            </button>
            <button class="ct_green_bnt w-100" data-bs-dismiss="modal" type='button' onClick={()=>{
                localStorage.removeItem("securpoint-web-access-token")
                localStorage.removeItem("secure-point-profile")
                navigate(webPaths?.Login, {
                  state: {
                    ...location?.state,
                    backgroundLocation: {
                      pathname: webPaths?.WebHome,
                      search: "",
                      hash: "",
                    },
                  },
                })
            }}>Log Out</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LogoutModal
